const els = {
    $story: () => $('[data-story]'),
    $intro: () => els.$story().find('[data-intro]'),
    $headlineWithYearFlag: () => els.$story().find('[data-heading-with-year-flag]'),
    $headline: () => els.$story().find('[data-headline]'),
    $content: () => els.$story().find('[data-content]'),
    $blocksWrap: () => els.$story().find('[data-blocks]'),
    $blocks: () => els.$story().find('[data-block]'),
    $blockButtons: () => els.$story().find('[data-block-button]'),
    $activeBlock: () => els.$blocks().filter('[data-active]'),
    $timeline: () => els.$story().find('[data-timeline]'),
    $timelineHeading: () => els.$timeline().find('[data-heading]'),
    $timelinePole: () => els.$timeline().find('[data-pole]:visible'),
    $eventsWrap: () => els.$timeline().find('[data-events]'),
    $events: () => els.$timeline().find('[data-event]'),
    $eventsLine: () => els.$timeline().find('[data-line]'),
    $eventsPoints: () => els.$eventsWrap().find('[data-point]'),
    $banner: () => els.$story().find('[data-banner]'),
    $bannerImage: () => els.$banner().find('img'),
};

export default els;

